// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.maintenance.properties.RentalManagerUserMaintenancePropertiesWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { RentalManagerUserMaintenancePropertyListDto } from '../..';

export const RentalManagerUserMaintenancePropertiesWebApiHandler_list_Path =
  '/api/web/v1/users/maintenance/properties/list';

/**
 * Get list of properties for user to create maintenance tasks
 */
export const RentalManagerUserMaintenancePropertiesWebApiHandler_list = (environment?: RentalManagerEnvironment) => {
  return frontEndRequestV2<never, never, RentalManagerUserMaintenancePropertyListDto>({
    endpoint: RentalManagerUserMaintenancePropertiesWebApiHandler_list_Path,
    method: 'GET',
    contextPath: '/rental-manager-api',
    environment,
  });
};
